import { z } from 'zod';

/** The page of a source's run history, kept in the URL. */
export const sourceSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type SourceSearch = z.output<typeof sourceSearchSchema>;
